export default __webpack_public_path__ + "static/media/bismAllah.f36f9153.png";